
export enum RelationType {
  Parents = 'parents',
  Children = 'children',
  Related = 'related',
  Clean = 'archive',
  // We used to use the 'archive' type to reference both the clean copy in original item and
  // the original item in clean copy which is problematic in some places to decide which
  // is the original item and which is the clean copy. Now we will use this new relation
  // type on the clean copy to indicate the original copy instead.
  CleanOriginal = 'archiveOriginal',
  ChangeNotification = 'changeNotification', // one way relation where the items of this relation type should be notified

  // The item for filename.mogrt
  MogrtParent = 'mogrtParent',

  // The item(s) corresponding to the extra files (e.g. aegraphic, jpg etc.) that are
  // added to the bin automatically under "Motion Graphics Template Media" bin when a
  // mogrt is imported via importMGT API.
  MogrtChildren = 'mogrtChildren',
}

export function isRelationType(relationType: unknown): relationType is RelationType {
  if (typeof relationType !== 'string') return false;
  return Object.values(RelationType).includes(relationType as RelationType);
}

export type RelationsEntity = { [k in RelationType]?: string[] };
